/**
 * The colour that marks "the other version" in a comparison, defined once so
 * every surface that marks it agrees.
 *
 * Not a theme token: there is no pink in the palette. The values read on both
 * the light and the dark ground.
 */
export const COMPARE_TINT = {
  /** Text and other full-strength marks. */
  strong: 'hsl(330, 82%, 58%)',
  /** A wash behind a row, over either ground. */
  wash: 'hsla(330, 82%, 58%, 0.14)',
  /** The same wash, one step up, for a hover or a connecting rule. */
  washStrong: 'hsla(330, 82%, 58%, 0.28)',
} as const
